
import React from 'react';
import { Assessment } from '@/types/assessment';

interface NoResponsesPlaceholderProps {
  assessment: Assessment;
}

const NoResponsesPlaceholder: React.FC<NoResponsesPlaceholderProps> = ({ assessment }) => {
  return (
    <div className="flex flex-col items-center justify-center p-12 border border-dashed rounded-lg">
      <h3 className="text-xl font-medium mb-2">No responses yet</h3>
      <p className="text-muted-foreground text-center mb-6">
        There are no responses for this assessment yet. Share the assessment link with others to collect responses.
      </p>
    </div>
  );
};

export default NoResponsesPlaceholder;
